import { useQuery } from '@tanstack/react-query';
import { getMe } from '@/graph/modules/me';
import { getOrganization } from '@/graph/modules/organization';
import { getSubscribedSkus } from '@/graph/modules/subscribedSkus';
import { getCopilotUsageUserDetail } from '@/graph/modules/copilotUsage';
import { evaluateEntitlements } from '@/features/entitlement/engine';
import { summariseAdoption } from '@/features/adoption/adoption';

export function useMe() {
  return useQuery({ queryKey: ['me'], queryFn: getMe });
}

export function useOrganization(enabled = true) {
  return useQuery({
    queryKey: ['organization'],
    queryFn: getOrganization,
    enabled,
  });
}

/**
 * C2 — runs the entitlement engine over live SKU data. `select` keeps the
 * transform out of the component and memoised by the query cache.
 */
export function useEntitlements(enabled = true) {
  return useQuery({
    queryKey: ['subscribedSkus'],
    queryFn: getSubscribedSkus,
    enabled,
    select: (skus) => evaluateEntitlements(skus),
  });
}

/**
 * C3 — Copilot adoption. `select` runs the pure adoption summary over the beta
 * usage rows, memoised by the query cache and kept out of the component.
 */
export function useCopilotAdoption(enabled = true) {
  return useQuery({
    queryKey: ['copilotUsage', 'D30'],
    queryFn: () => getCopilotUsageUserDetail('D30'),
    enabled,
    select: (rows) => summariseAdoption(rows),
  });
}
